export function PrivacyPage() {
  return (
    <main className="section page pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <header className="mb-12">
          <p className="eyebrow text-magma">Trasparenza e Sicurezza</p>
          <h1 className="text-4xl md:text-5xl font-display uppercase tracking-wider mb-4 text-white">Privacy Policy</h1>
          <p className="text-neutral-400 text-sm">Ultimo aggiornamento: 28 Luglio 2026</p>
        </header>

        <div className="space-y-12 text-neutral-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">1. Titolare del Trattamento</h2>
            <p className="mb-4">
              Ai sensi della normativa vigente in materia di protezione dei dati personali (Regolamento UE 2016/679 - GDPR), il Titolare del trattamento è:
            </p>
            <div className="bg-obsidian border border-neutral-800 p-6 rounded-md">
              <p><strong>Giovanni Antonelli</strong></p>
              <p className="mt-2">Email per questioni di privacy: <strong>info@blastcore.it</strong></p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">2. Dati Trattati, Finalità e Basi Giuridiche</h2>
            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-bold text-white mb-2">A. Dati di Navigazione e Log di Sicurezza</h3>
                <p>I sistemi informatici preposti al funzionamento di questo sito web acquisiscono alcuni dati la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet (indirizzi IP e timestamp delle richieste).</p>
                <div className="mt-3 bg-obsidian border-l-4 border-magma p-4 text-sm text-neutral-400">
                  <p><strong className="text-neutral-200">Finalità:</strong> Protezione dell'infrastruttura da attacchi informatici (es. DDoS) e garanzia del corretto funzionamento tecnico.</p>
                  <p className="mt-1"><strong className="text-neutral-200">Base Giuridica:</strong> Legittimo interesse del titolare a garantire la sicurezza del network (Art. 6, par. 1, lett. f GDPR).</p>
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-bold text-white mb-2">B. Dati di Gioco (Network Minecraft)</h3>
                <p>Quando accedi al nostro server Minecraft ufficiale <code>play.blastcore.it</code>, raccogliamo ed esponiamo pubblicamente su questo sito i tuoi dati di gioco associati all'account Minecraft (Mojang/Microsoft).</p>
                <ul className="list-disc list-inside mt-3 space-y-1 text-neutral-400 ml-2">
                  <li>Minecraft UUID (Identificativo Unico alfanumerico)</li>
                  <li>Username Minecraft</li>
                  <li>Statistiche competitive (MMR, vittorie, sconfitte, uccisioni, morti)</li>
                  <li>Cronologia delle partite e partecipazione a tornei</li>
                </ul>
                <div className="mt-3 bg-obsidian border-l-4 border-magma p-4 text-sm text-neutral-400">
                  <p><strong className="text-neutral-200">Finalità:</strong> Fornire il servizio di leaderboard, mantenere l'integrità competitiva e mostrare i profili giocatore pubblici.</p>
                  <p className="mt-1"><strong className="text-neutral-200">Base Giuridica:</strong> Esecuzione di un contratto (accettazione dei Termini di Servizio all'ingresso nel server, Art. 6, par. 1, lett. b GDPR) e legittimo interesse a mantenere uno storico competitivo.</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">3. Servizi di Terze Parti e Destinatari dei Dati</h2>
            <p className="mb-4">BlastCore non cede né vende dati a terzi. Tuttavia, utilizziamo alcuni servizi infrastrutturali essenziali che potrebbero elaborare il tuo indirizzo IP:</p>
            <ul className="space-y-4">
              <li className="bg-obsidian border border-neutral-800 p-5 rounded-md">
                <strong className="text-white">Cloudflare</strong> (Cloudflare, Inc., USA):<br/> Utilizzato come Content Delivery Network (CDN) e Web Application Firewall (WAF) per la sicurezza, velocità e protezione DDoS. 
                Il trasferimento dei dati verso gli Stati Uniti è garantito dal Data Privacy Framework.
              </li>
              <li className="bg-obsidian border border-neutral-800 p-5 rounded-md">
                <strong className="text-white">MCHeads</strong> (mc-heads.net):<br/> Utilizzato per recuperare dinamicamente e mostrare l'avatar e il modello 3D del tuo personaggio Minecraft sul sito. 
                Il tuo browser si connette direttamente a questo servizio, trasmettendo il tuo indirizzo IP e richiedendo l'immagine pubblica di Minecraft.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">4. Conservazione dei Dati</h2>
            <p>
              I <strong>dati di navigazione</strong> (log web e di sicurezza) vengono conservati per il tempo strettamente necessario alla diagnostica, dopodiché vengono automaticamente cancellati o anonimizzati, salvo diverse disposizioni dell'Autorità Giudiziaria in caso di reati informatici.
            </p>
            <p className="mt-3">
              I <strong>dati di gioco</strong> (statistiche, MMR, storico) sono conservati a tempo indeterminato per mantenere l'integrità storica delle classifiche di BlastCore, a meno che tu non ne richieda esplicitamente la cancellazione (che comporterà anche l'impossibilità di partecipare alle competizioni).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">5. I Tuoi Diritti (GDPR)</h2>
            <p className="mb-3">In conformità agli artt. 15-22 del GDPR, in qualità di interessato, hai il diritto di:</p>
            <ul className="list-disc list-inside space-y-2 text-neutral-400 bg-obsidian p-5 rounded-md border border-neutral-800">
              <li><strong>Accesso:</strong> Richiedere conferma se sia in corso o meno un trattamento di dati che ti riguardano;</li>
              <li><strong>Rettifica:</strong> Chiedere l'aggiornamento di dati inesatti (es. l'aggiornamento del tuo Username se disallineato da Mojang);</li>
              <li><strong>Cancellazione (Oblio):</strong> Richiedere la rimozione del tuo profilo e dei log (nei limiti della conservazione per fini di sicurezza);</li>
              <li><strong>Limitazione & Opposizione:</strong> Opporti al trattamento per motivi legittimi o chiederne la limitazione;</li>
              <li><strong>Reclamo:</strong> Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali qualora tu ritenga che il trattamento violi il GDPR.</li>
            </ul>
            <p className="mt-4 text-sm">
              Per esercitare tali diritti, ti preghiamo di inviare una richiesta all'indirizzo email indicato nella Sezione 1. Per richieste relative all'account Minecraft, ti potremmo chiedere di effettuare l'accesso al server per verificare la tua identità e titolarità del profilo.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
